// src/pages/LoginPage.jsx
import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const font = {
  mono:      '"JetBrains Mono", monospace',
  condensed: '"Barlow Condensed", sans-serif',
  body:      '"Barlow", sans-serif',
};

const LoginPage = () => {
  const { isLoggedIn, authToken } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn && authToken) {
      // Verify admin status before redirecting
      fetch(`${BACKEND_URL}/api/admin/check`, {
        headers: { Authorization: `Bearer ${authToken}` }
      })
        .then(r => r.json())
        .then(data => { if (data.is_admin) navigate('/admin'); })
        .catch(() => {});
    }
  }, [isLoggedIn, authToken]);

  const handleLogin = () => {
    window.location.href = `${BACKEND_URL}/api/auth/twitch/login?admin=true&force_login=true`;
  };

  return (
    <div style={{ background: '#000', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@900&family=Barlow:wght@300;400&family=JetBrains+Mono:wght@400;700&display=swap');`}</style>
      <div style={{ textAlign: 'center', maxWidth: 400, padding: '0 2rem', width: '100%' }}>

        {/* Logo */}
        <div style={{ marginBottom: '3rem' }}>
          <div style={{ fontFamily: font.condensed, fontWeight: 900, fontSize: '4rem', letterSpacing: '-0.02em', color: '#fff', lineHeight: 1 }}>BGN</div>
          <div style={{ fontFamily: font.mono, fontSize: '0.6rem', color: '#333', letterSpacing: '0.25em', marginTop: 4 }}>ADMIN PORTAL</div>
        </div>

        {/* Login card */}
        <div style={{ background: '#0d0d0d', border: '1px solid #1a1a1a', padding: '2.5rem' }}>
          <div style={{ fontFamily: font.mono, fontSize: '0.6rem', color: '#444', letterSpacing: '0.2em', marginBottom: '1.5rem' }}>// AUTHORIZED ACCESS ONLY</div>

          <button
            onClick={handleLogin}
            style={{ width: '100%', background: '#fff', color: '#000', border: 'none', padding: '0.9rem', fontFamily: font.mono, fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.1em', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: '1.25rem' }}
            onMouseEnter={e => e.currentTarget.style.background = '#ddd'}
            onMouseLeave={e => e.currentTarget.style.background = '#fff'}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#000"><path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z"/></svg>
            LOGIN WITH TWITCH
          </button>

          <p style={{ fontFamily: font.body, fontWeight: 300, fontSize: '0.78rem', color: '#444', lineHeight: 1.6 }}>
            Access is restricted to authorized BGN admins only. Unauthorized access attempts are logged.
          </p>
        </div>

        <div style={{ fontFamily: font.mono, fontSize: '0.58rem', color: '#2a2a2a', letterSpacing: '0.1em', marginTop: '1.5rem' }}>
          BLACK GAMERS NETWORK © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;